import i18n from "../../../../i18n"

const OpeningTimesDays = ({dayName, day, openingHours, }) => {
    return  <tr>
        <td>{dayName}</td>
        <td>{openingHours[day+ '_open_time'] ? 
            openingHours[day + '_open_time'] + ' - ' + openingHours[day + '_close_time'] :
            i18n.t('Gesloten')
            }
        </td>
    </tr>


}

export default OpeningTimesDays